export { default } from './Tooltip';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Tooltip/index.js
// module id = 190
// module chunks = 0